<template>
  <div v-if="bodyShow" style="background-color: #fff">
    <div class="card">
      <h2>恭喜你获得闯关福利——知识晶体卡片一张！<br />欢迎分享给朋友，一起发现探索自我的奥妙！</h2>
      <img @click="img_preview(data.test.example_img)" :src="data.test.example_img" alt="" />
      <h3>*长按保存图片</h3>
    </div>
    <!-- 判断是否是未解锁还是已通关 -->
    <!-- 未解锁 -->
    <div class="next next_lock" v-if="!classes_obj.bool">
      {{classes_obj.val}}
    </div>
    <!-- 已通关 -->
    <div class="next" @click="toListView()" v-else-if="next.last">恭喜你 你通关了哟</div>
    <div v-else>
      <!-- <div v-if="next.complete" class="next next_lock">
        恭喜你 你通关了哟
      </div>
      <div v-else  class="next"> -->
      <div  class="next">
        
        <!-- 已解锁 -->
        <div v-if="next.same" @click="list_link">
          <!-- 1测评2音频3任务4小组讨论5案例 -->
          <div v-if="next.data.type == 1">开启“测评”</div>
          <div v-else-if="next.data.type == 2">开启下一课程</div>
          <div v-else-if="next.data.type == 3">开启“任务”</div>
          <div v-else-if="next.data.type == 5">开启“案例分析”</div>
        </div>
        <div class="next" v-else @click="list_link">挑战下一关</div>
      </div>
    </div>
    <!-- 关卡介绍 -->
    <public-level :level_list_id="level_list_id"></public-level>
    <!-- 引入返回列表页面 -->
    <capacity-fixed :cid="$route.query.cid"></capacity-fixed>
  </div>
</template>
<script>
import { audioTest} from "@/api/course"
import { shareCon} from "@/utils/wxconfig"
import wx from "weixin-js-sdk"
import { ImagePreview} from "vant";
import CapacityFixed from "@c/course/capacity-fixed"
import PublicLevel from '@c/course/public-level'
import Bus from "@/utils/bus"
import {dateFormat} from '@/utils/tools'
export default {
  data() {
      return {
        bodyShow: false,
        data: {},
        next: {},
        level_list_id:'',
        // 是否开课
        classes_obj:{
          bool:true,
          val:''
        }
      }
    },
    components: {
      CapacityFixed,
      PublicLevel
    },
    methods: {
      /*
       *@param: 
       *@return: 
       *@Description: 跳转列表页
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-23 15:59:19
      */
      toListView(){
        this.$router.push({
          path:'/list',
          query:{
            cid:this.$route.query.cid
          }
        });
      },
      /*
       *@param: link 图片地址
       *@Description: 卡片预览
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-09 17:13:01
      */
      img_preview(link) {
        let ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          wx.previewImage({
            current: [link], // 当前显示图片的http链接
            urls: [link] // 需要预览的图片http链接列表
          });
        } else {
          ImagePreview({
            images: [link],
            // startPosition: num,
            showIndex: false,
            onClose() {
              // do something
            }
          });
        }
      },
      // 开启下一个任务
      list_link() {
        let item = this.next.data;
        if (item.type == 1) {
          if(item.link.startsWith('http')){
            window.location.href = item.link+'?level_list_id=' + item.id;
          }else{
            this.$router.push({
              path:item.link,
              query:{
                level_list_id:item.id
              }
            })
          }
        } else if (item.type == 2) {
          this.$router.push('/course_content?cid=' + item.cid + '&level_list_id=' + item.id+'&cpid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 3) {
          this.$router.push(item.link + '?cid=' + item.cid +'&level_list_id=' + item.id+ '&pid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 5) {
          this.$router.push('/case_analysis?id=' + item.id +'&level_list_id=' + item.id+ '&cid=' + item.cid)
        }
      },
      pullData() {
        // loading
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let q = this.$route.query;
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        audioTest({
            cid: q.cid,
            testid: q.testid,
            table_id: q.table_id,
            cpid: q.cpid
          })
          .then((data) => {
            this.$toast.clear();
            if (data.code === 10002) {
              this.$toast(data.data.msg);
              return
            }
            this.data = data;
            this.next = data.next;
            // 计算日期大小，判断是否有下一关或者未解锁
            this.dataSize();
            if (this.next instanceof Array && this.next.length == 0) {
              this.$toast("配置错误");
              return
            }
            this.bodyShow = true;
            this.$toast.clear();
          })
      },
      /*
       *@param: 
       *@return: 
       *@Description: 比较日期时间大小
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-23 10:08:27
      */
      dataSize(){
        if(this.next.unlock_time){
          // 获取开课时间
          let d = dateFormat('yyyy-MM-dd hh:mm:ss',new Date(this.next.unlock_time*1000));
          let arr = d.split(' ');
          let date_ = arr[0].replace(/-/g, '');
          let time_ = arr[0].replace(/:/g, '');
          // 获取当前时间
          let date =new Date();
          let rq = String(date.getFullYear())+String(date.getMonth()+1)+String(date.getDate());
          let time = String(date.getHours())+String(date.getMinutes())+String(date.getSeconds());
          // 如果开课日期大于当前日期
          if(date_>rq || (date_==rq && time_>time)){
            this.classes_obj.bool=false;
            this.classes_obj.val='暂未解锁下一关卡';
            
          }
        }
        
      }
    },
    created() {
      Bus.$on('documentTitle',(data)=>{
        document.title = data.level.name;
      });
      this.pullData();
      shareCon("course", this);
    }
}
</script>
<style lang="scss" scope>
.card {
  padding: 40px 30px;
  h2 {
    line-height: 48px;
    color: #333;
    font-size: 32px;
    text-align: justify;
  }
  img {
    width: 100%;
    margin-top: 38px;
  }
  h3 {
    text-align: right;
    margin-top: 10px;
    color: #999;
    font-size: 24px;
  }
}

.next {
  max-width: 750px;
  width: 100%;
  height: 98px;
  background: rgba(235, 80, 50, 1);
  line-height: 98px;
  text-align: center;
  color: #fff;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 34px;
}

.next_lock {
  background-color: #ccc;
}
</style>
